
function ExitPolicySummary(props) {
  const accept = (props.summary.accept ? props.summary.accept : []);
  const reject = (props.summary.reject ? props.summary.reject : []);
  return (
    <pre className="pre-scrollable">
      {accept.length > 0 && "accept\n"}
      {accept.map((value, index) => (
        <span
          key={index}
          className="text-success"
        >{"  *:" + value + "\n"}</span>
      ))}
      {reject.length > 0 && "reject\n"}
      {reject.map((value, index) => (
        <span
          key={index}
          className="text-danger"
        >{"  *:" + value + "\n"}</span>
      ))}
    </pre>
  )
}

export default ExitPolicySummary;
